import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoanApplication, ApplicationAccessSpecifier } from '@app/applications/applications.model';
import { ApplicationService } from '@app/applications/application.service';
import { ReferenceCodeService } from '@app/admin/reference-code/reference-code.service';
import { DateAdapter, MatSnackBar } from '@angular/material';
import { BusinessEntity } from '@app/leads/leads.model';
import { ReferenceCode } from '@app/admin/reference-code/reference-code.model';
import { IgFileService } from '@ig-core/form/igFile.service';
import { ValidationService } from '../../../application-validators/validation.service';
import { ImagePreviewDialogService } from '@app/utils/image-preview-dialog/image-preview-dialog.service';
import { FileUploadService } from '@app/utils/file-upload/file-upload.service';
import { FolderFilesComposite } from '@app/applications/application-details/loanInformation/loan-folder-files/loan-folder-files.model';
import { ConfirmationDialogService } from '@app/utils/confirmation-dialog/confirmation-dialog.service';
import * as fileSaver from 'file-saver';
import { OccupationInformation } from '../occupationInformation/occupation-information.model';
import { IncomeProofDTO } from './income-proofs.model';
@Component({
  selector: 'eng-income-proofs',
  templateUrl: 'income-proofs.template.html',
  styleUrls: ['../../application-details.styles.scss', './income-proofs.style.scss']
})
export class IncomeProofsComponent implements OnInit {

  @Input()
  application: LoanApplication;

  @Input()
  occupation: OccupationInformation;
  @Input()
  menuCode: string;

  incomeProofs: IncomeProofDTO[] = [];
  selectedIncomeProof: IncomeProofDTO;

  incomeForm: FormGroup;

  incomeProofDocumentTypes: ReferenceCode[] = [];
  allFilesInFolder: FolderFilesComposite;

  isFormDisabled: boolean;
  showForm: boolean;
  allowAccess: Boolean;
  menuItemAllowAccess: boolean;

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;

  constructor(private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private referenceCodeService: ReferenceCodeService,
    private fileService: IgFileService,
    private _snackbar: MatSnackBar,
    private dateAdapter: DateAdapter<Date>,
    private validationService: ValidationService,
    private imagePreviewDialogService: ImagePreviewDialogService,
    private confirmationDialogService: ConfirmationDialogService,
    private fileUploadService: FileUploadService) {
    this.incomeForm = this.formBuilder.group({
      incomeProofType: ['', Validators.required],
    });
    this.dateAdapter.setLocale('en-IN');
    this.allowAccess = this.applicationService.allowAccess;
  }

  ngOnInit() {
    this.isFormDisabled = true;
    this.getRefCodes();
    this.fetchIncomeProofs();
    this.getMenuItemAccess();
  }

  getRefCodes() {
    this.referenceCodeService.getRefCodesForClassifier('income_proof').subscribe((response: any) => {
      this.incomeProofDocumentTypes = response;
    });
  }

  fetchIncomeProofs() {
    this.showForm = false;
    this.applicationService.getIncomeProofs(this.application.uid, this.occupation.uid)
      .subscribe((response: any) => {
        if (response) {
          this.incomeProofs = response.body;
          this.incomeProofs.forEach((element, index) => {
            this.incomeProofs[index]["deleteBtnDisabled"] = true;
          });
          this.showForm = (this.incomeProofs && this.incomeProofs.length > 0);
          if (this.incomeProofs.length != 0) {
            this.showForm = true;
            this.buildIncomeProofForm();
          }
        }
      });
  }

  buildIncomeProofForm(incomeProof?: IncomeProofDTO) {
    if (this.showForm) {
      if (!incomeProof) {
        incomeProof = this.incomeProofs[0];
        this.incomeProofs[0].deleteBtnDisabled = false;
      }
      this.incomeForm.patchValue({
        incomeProofType: incomeProof.proofType,

      });
      this.selectedIncomeProof = incomeProof;
      this.getSelectedFolderFiles(this.selectedIncomeProof.fileFolderUid)
      this.incomeForm.disable();
    }
  }

  addNewIncomeProof(incomeProof) {
    this.showForm = true;
    this.incomeProofs.forEach((element, i) => {
      this.incomeProofs[i].deleteBtnDisabled = true;
    });
    if (!incomeProof) incomeProof = new IncomeProofDTO();
    this.buildIncomeProofForm(incomeProof);
    this.incomeForm.enable();
    this.isFormDisabled = false;

  }
  changeSelectedIncomeProof(incomeProof?: IncomeProofDTO, index?: number, from?: string) {
    if (!incomeProof) incomeProof = new IncomeProofDTO();
    this.showForm = true;
    this.incomeProofs.forEach((element, i) => {
      this.incomeProofs[i].deleteBtnDisabled = true;
    });
    if (from != "new") {
      this.incomeProofs[index].deleteBtnDisabled = false;
    }
    this.buildIncomeProofForm(incomeProof);
  }

  saveIncomeProof() {
    this.validationService.markFormGroupTouched(this.incomeForm)
    if (!this.isFormDisabled && this.incomeForm.valid) {

      let incomeProofUid = this.selectedIncomeProof.uid ? this.selectedIncomeProof.uid : "0";
      let incomeProofFormFields = this.incomeForm.getRawValue();
      this.selectedIncomeProof.proofType = incomeProofFormFields.incomeProofType;

      this.applicationService.saveIncomeProof(this.application.uid,
        this.occupation.uid, incomeProofUid, this.selectedIncomeProof).toPromise().then(
          (_success) => {
            this._snackbar.open("Income Proof updated successfully", "Close", {
              duration: 2000,
            });
            this.isFormDisabled = true;
            this.fetchIncomeProofs();
          }, (failure) => {
            let errormesg = []
            errormesg.push(failure)
            this.applicationService.displayErrorMessages(errormesg);
            console.log(failure);
          }
        );
    }
  }

  enableDisableForm() {
    this.incomeForm.enable();
    this.isFormDisabled = false;
  }

  closeForm() {
    this.incomeProofs.forEach((element, i) => {
      this.incomeProofs[i].deleteBtnDisabled = true;
    });
    if (this.incomeProofs && this.incomeProofs.length > 0) {
      this.buildIncomeProofForm();
    } else {
      this.showForm = false;
    }
    this.incomeForm.disable();
    this.isFormDisabled = true;
  }

  //this function will trigger onclicking of image,will open up a mat-dailog
  openContentElement() {
    this.imagePreviewDialogService.open({ "images": this.allFilesInFolder })
  }

  //this function open up the image upload dailog box
  //if file upload should allow single and multiple file upload, we need to pass "uploadType":"multiple"
  openImageFileUploadDialog() {
    if (this.selectedIncomeProof.fileFolderUid) {
      this.fileUploadService.open({ "uploadType": "multiple", "folderUid": this.selectedIncomeProof.fileFolderUid, "applicationUid": this.application.uid, "files": this.allFilesInFolder.fileInfo })
      this.fileUploadService.confirmed().subscribe(data => {
        this.getSelectedFolderFiles(data.folderUid)
      })

    } else {
      this._snackbar.open("Please add a folder to upload files", "Close", {
        duration: 5000,
      });
    }
  }

  getSelectedFolderFiles(folderUid) {
    if (folderUid) {
      this.applicationService.getAllFilesInApplicationFolder(this.application.uid, folderUid).subscribe((response: any) => {
        if (response) {
          this.allFilesInFolder = response.body;
          this.allFilesInFolder.fileInfo.forEach(element => {
            if (element.fileSize) {
              element["convertedFileSize"] = this.applicationService.bytesToSize(element.fileSize)
            }
          });
        }
      });
    }
  }

  //this function will call onclick of download icon in file's section
  downloadFile(file) {
    this.applicationService.downloadFileFromApplicationFolder(this.application.uid, file.folderUid, file.fileId).subscribe(image => {
      const blob = new Blob([image.data], { type: file.type });
      fileSaver.saveAs(blob, file.fileName);
      this._snackbar.open("File has been downloaded successfully", "Close", {
        duration: 5000,
      });
    })
  }

  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess() {
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
          .find(accessSpecifier => accessSpecifier.category === this.menuCode);
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }

  //this function will be called on click of delete icon on Kyc
  deleteIncomeProof(selectedIncomeProof) {
    this.applicationService.incomeProofDelete(this.application.uid,selectedIncomeProof.uid).subscribe((response) => {
      this._snackbar.open("Income proof deleted successfully", "Close", {
        duration: 2000,
      });
      this.fetchIncomeProofs();
    }, (failure) => {
      let errormesg = []
      errormesg.push("Income Proof deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  openDeleteConfirmation() {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this Income Proof?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteIncomeProof(this.selectedIncomeProof)
      }
    })
  }

  //this function will be called on click of delete icon on file list
  deleteFile(selectedFile) {
    this.applicationService.fileDelete(this.application.uid, selectedFile.uid).subscribe((response) => {
      if (response.body.status == "success") {
        this._snackbar.open("File deleted successfully", "Close", {
          duration: 2000,
        });
        this.getSelectedFolderFiles(this.selectedIncomeProof.fileFolderUid);
      } else {
        let errormesg = []
        errormesg.push("File deleted failed")
        errormesg.push(response.body.message)
        this.applicationService.displayErrorMessages(errormesg);
      }
    }, (failure) => {
      let errormesg = []
      errormesg.push("File deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  openfileDeleteConfirmation(selectedFile) {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this File?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteFile(selectedFile)
      }
    })

  }

  viewPdf(file) {
    this.fileService.fileStreamById(file.fileId, "false").subscribe(res => {
      window.open(res.data, '_blank');
    })
  }

}